import { isPersonalLinkPath } from '~/utils/agentReferral';
import { stripLocalePrefix } from '~/utils/i18n/locale';
import { isLandingPath } from '~/utils/landing/landingPage';

// Focused single-purpose pages without the floaty (bare /lp/telegram, help, contract signing).
const HIDDEN_EXACT_PATHS: readonly string[] = ['/lp/telegram', '/help'];

/**
 * The WhatsApp-to-account-manager floaty is the signed-in agent's AM contact: never on the public
 * landings (/, /international, /uae) and never for signed-out visitors.
 */
export const shouldShowSupportFloaty = ({ path, isSignedIn }: { path: string; isSignedIn: boolean }): boolean => {
  if (!isSignedIn || isLandingPath(path)) return false;
  const bare = stripLocalePrefix(path);
  return !HIDDEN_EXACT_PATHS.includes(bare) && !bare.startsWith('/sign') && !isPersonalLinkPath(bare);
};
